import { useEffect } from "react";

import { useAppDispatch } from "../../store";
import { AuthEventChannel, AuthEventType } from "../shared/enums/auth-events";
import { sessionExpired } from "../store/auth.slice";

/**
 * Hook to handle authentication events from Service Worker
 * Listens for 401 errors via BroadcastChannel and sends the user back to login.
 *
 * Сигнал нужен именно отсюда: на 401 service worker отдаёт странице закешированный
 * ответ (`cache-with-etag`), поэтому сама страница протухшую сессию не замечает.
 */
export const useAuthEvents = (): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (typeof BroadcastChannel === "undefined") {
      return;
    }

    const authChannel = new BroadcastChannel(AuthEventChannel.AUTH_EVENTS);

    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === AuthEventType.LOGOUT_REQUIRED) {
        dispatch(sessionExpired());
      }
    };

    authChannel.addEventListener("message", handleMessage);

    return () => {
      authChannel.removeEventListener("message", handleMessage);
      authChannel.close();
    };
  }, [dispatch]);
};
